import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { useClient } from '../../../app/api/client-api';
import { getLiquidityCalculatorCalculation, type LiquidityCalculatorCalculationDto } from '../../../app/api/generated/client';
import { queryKeys } from '../query-keys';

export function useLiquidityCalculatorCalculation(): UseQueryResult<LiquidityCalculatorCalculationDto, AxiosError> {
    const { data: client } = useClient();
    const queryKey = useMemo(() => queryKeys.liquidityCalculatorCalculation(client?.partnerUuid), [client?.partnerUuid]);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getLiquidityCalculatorCalculation({ query: { clientId: client!.id }, signal }).then((result) => result.data),
        enabled: !!client,
    });
}
